import { render, staticRenderFns } from "./Widget-chart.vue?vue&type=template&id=00727b2a&"
import script from "./Widget-chart.vue?vue&type=script&lang=js&"
export * from "./Widget-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports